import { useSanitizedHtml } from '../hooks/useSanitizedHtml';

const SanitizedHtmlComponent = ({ dirtyHtml, options }: { dirtyHtml: string; options?: any }) => {
    const sanitizedHtml = useSanitizedHtml(dirtyHtml, options);
    return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default SanitizedHtmlComponent;
